import { TestDefinition, QuestionType } from '../../types';

export const TESTS_ESTRES: TestDefinition[] = [
  {
    id: 'pss-10',
    code: 'PSS-10',
    name: 'Perceived Stress Scale - 10',
    category: 'Stress',
    description: 'A 10-item scale measuring the degree to which life situations are perceived as stressful. Developed by Cohen et al. (1983). Self-administered, evaluates perceived stress in the last month.',
    questions: [
      {
        id: 'q1',
        text: '1. In the last month, how often have you been upset because of something that happened unexpectedly?',
        type: QuestionType.LIKERT,
        options: [
          {label: 'Never', value: 0},
          {label: 'Almost never', value: 1},
          {label: 'Sometimes', value: 2},
          {label: 'Fairly often', value: 3},
          {label: 'Very often', value: 4}
        ]
      },
      {
        id: 'q2',
        text: '2. In the last month, how often have you felt that you were unable to control the important things in your life?',
        type: QuestionType.LIKERT,
        options: [
          {label: 'Never', value: 0},
          {label: 'Almost never', value: 1},
          {label: 'Sometimes', value: 2},
          {label: 'Fairly often', value: 3},
          {label: 'Very often', value: 4}
        ]
      },
      {
        id: 'q3',
        text: '3. In the last month, how often have you felt nervous and stressed?',
        type: QuestionType.LIKERT,
        options: [
          {label: 'Never', value: 0},
          {label: 'Almost never', value: 1},
          {label: 'Sometimes', value: 2},
          {label: 'Fairly often', value: 3},
          {label: 'Very often', value: 4}
        ]
      },
      {
        id: 'q4',
        text: '4. In the last month, how often have you felt confident about your ability to handle your personal problems?',
        type: QuestionType.LIKERT,
        options: [
          {label: 'Never', value: 4},
          {label: 'Almost never', value: 3},
          {label: 'Sometimes', value: 2},
          {label: 'Fairly often', value: 1},
          {label: 'Very often', value: 0}
        ]
      },
      {
        id: 'q5',
        text: '5. In the last month, how often have you felt that things were going your way?',
        type: QuestionType.LIKERT,
        options: [
          {label: 'Never', value: 4},
          {label: 'Almost never', value: 3},
          {label: 'Sometimes', value: 2},
          {label: 'Fairly often', value: 1},
          {label: 'Very often', value: 0}
        ]
      },
      {
        id: 'q6',
        text: '6. In the last month, how often have you found that you could not cope with all the things that you had to do?',
        type: QuestionType.LIKERT,
        options: [
          {label: 'Never', value: 0},
          {label: 'Almost never', value: 1},
          {label: 'Sometimes', value: 2},
          {label: 'Fairly often', value: 3},
          {label: 'Very often', value: 4}
        ]
      },
      {
        id: 'q7',
        text: '7. In the last month, how often have you been able to control irritations in your life?',
        type: QuestionType.LIKERT,
        options: [
          {label: 'Never', value: 4},
          {label: 'Almost never', value: 3},
          {label: 'Sometimes', value: 2},
          {label: 'Fairly often', value: 1},
          {label: 'Very often', value: 0}
        ]
      },
      {
        id: 'q8',
        text: '8. In the last month, how often have you felt that you were on top of things?',
        type: QuestionType.LIKERT,
        options: [
          {label: 'Never', value: 4},
          {label: 'Almost never', value: 3},
          {label: 'Sometimes', value: 2},
          {label: 'Fairly often', value: 1},
          {label: 'Very often', value: 0}
        ]
      },
      {
        id: 'q9',
        text: '9. In the last month, how often have you been angered because of things that happened that were outside of your control?',
        type: QuestionType.LIKERT,
        options: [
          {label: 'Never', value: 0},
          {label: 'Almost never', value: 1},
          {label: 'Sometimes', value: 2},
          {label: 'Fairly often', value: 3},
          {label: 'Very often', value: 4}
        ]
      },
      {
        id: 'q10',
        text: '10. In the last month, how often have you felt difficulties were piling up so high that you could not overcome them?',
        type: QuestionType.LIKERT,
        options: [
          {label: 'Never', value: 0},
          {label: 'Almost never', value: 1},
          {label: 'Sometimes', value: 2},
          {label: 'Fairly often', value: 3},
          {label: 'Very often', value: 4}
        ]
      }
    ],
    interpretations: [
      { min: 0, max: 13, label: 'Low Stress', color: 'bg-green-100 text-green-800' },
      { min: 14, max: 26, label: 'Moderate Stress', color: 'bg-yellow-100 text-yellow-800' },
      { min: 27, max: 40, label: 'High Stress', color: 'bg-red-200 text-red-900' }
    ]
  }
];
